import { useDispatch, useSelector } from "react-redux";
import { Button } from "dyl-components";
import { Dimmer, Loader, Segment } from "semantic-ui-react";
import basePath from "actions/basePath";
import authActions from "actions/auth/auth";
import "./index.scss";

const Simulation = ({ isSidebarOpen }) => {
    const { isSimulating, dyl_user_info, isLoggingOutUser } = useSelector(
        (state) => state.auth
    );
    const dispatch = useDispatch();
    const onExitSimulation = async () => {
        await dispatch(authActions.logout());
        window.open(basePath.SALES_HOST, "_self", "noopener,noreferrer");
    };
    if (!isSimulating) return null;
    if (isLoggingOutUser)
        return (
            <Dimmer active page>
                <Loader active>Exiting simulation...</Loader>
            </Dimmer>
        );
    return (
        <div className="Simulation">
            <Segment
                compact
                size="mini"
                basic
                className={`Simulation__controls ${
                    isSidebarOpen
                        ? "Simulation__controls--full"
                        : "Simulation__controls--squished"
                }`}
            >
                <span className="Simulation__controls-user">
                    {dyl_user_info.name} (You)
                </span>
                <Button size="mini" color="primary" onClick={onExitSimulation}>
                    Exit Simulate
                </Button>
            </Segment>
        </div>
    );
};

export default Simulation;
